import React from 'react';
import type { JSX } from 'react';
import { Input, FormGroup } from 'reactstrap';

interface LimitedTextareaProps {
  value: string | null;
  onChange: (value: string) => void;
  placeholder?: string;
  maxLength?: number;
  error?: boolean;
  disabled?: boolean;
}

export default function LimitedTextarea({
  value,
  onChange,
  placeholder = '',
  maxLength = 250,
  error = false,
  disabled,
}: LimitedTextareaProps): JSX.Element {
  const safeValue = value ?? ''; // garante que sempre seja string

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
    const val = e.target.value;
    if (val.length <= maxLength) {
      onChange(val);
    }
  };

  return (
    <div style={{ position: 'relative' }}>
      <Input
        type="textarea"
        value={safeValue}
        onChange={handleChange}
        placeholder={placeholder}
        style={{
          minHeight: '120px',
          resize: 'vertical',
          paddingBottom: '2rem',
          borderColor: error ? '#E44B39' : undefined,
        }}
        disabled={disabled}
      />
      <div
        style={{
          position: 'absolute',
          bottom: 8,
          right: 18,
          fontSize: '0.85rem',
          color: safeValue.length >= maxLength ? '#E44B39' : '#666',
        }}
      >
        {safeValue.length}/{maxLength}
      </div>
    </div>
  );
}
